import * as Actions from "../actions/accountInformation.actions";

const initialState = {
  list: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.ACCOUNT_INFO:
      return {
        ...state,
        list: action.list,
      };
    default:
      return state;
  }
};
